module.exports = __webpack_public_path__ + "img/adulto13.5d14e272.jpg";